import React, { lazy, useEffect } from 'react'

import Modal from 'react-modal'
import { useSelector, shallowEqual, useDispatch } from 'react-redux'
import { Route, Switch, Redirect, useLocation } from 'react-router-dom'
import styled from 'styled-components'

import { getPage } from './_actions'
import {
    Footer,
    Nav,
} from './Components'
import './css/App.scss'
import { minDevices, devices } from './Components/Common'

const Home = lazy(() => import(/* webpackChunkName: "Home" */ './Components/Content/Home'))
const IEModal = lazy(() => import(/* webpackChunkName: "IEModal" */ './Components/Global/IEModal'))
const PageView = lazy(() => import(/* webpackChunkName: "PageView" */ './Components/Content/PageView'))
const Testimonials = lazy(() => import(/* webpackChunkName: "Testimonials" */ './Components/Content/Testimonials'))
const EventForm = lazy(() => import(/* webpackChunkName: "EventForm" */ './Components/Content/EventForm'))

Modal.setAppElement('#root')

const Routes = () => {
    const dispatch = useDispatch()
    const { ie } = useSelector(state => state.content, shallowEqual)
    const { pathname } = useLocation()

    useEffect(() => {
        dispatch(getPage(pathname))
    }, [pathname])

    return (
        <>
            <Switch>
                <Route exact path='/' component={Home} />
                <Route exact strict path='/:url*' render={props => <Redirect to={`${props.location.pathname}/`} />} />
                <Route exact path='/testimonials/' component={Testimonials} />
                <Route exact path='/event-form/' component={EventForm} />
                <Route component={PageView} />
            </Switch>
            {ie ? <IEModal /> : ''}
        </>
    )
}

export const App = () => {
    const { menuOpen } = useSelector(state => state.content, shallowEqual)
    return (
        <MainPage>
            <Route path='*' component={Nav} />
            <PageWrap menu={menuOpen}>
                <Routes />
                <Route path='*' component={Footer} />
            </PageWrap>
        </MainPage>
    )
}

const PageWrap = styled.main`
    flex: 1;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    transition: transform 0.2s ease-out;
    
    @media ${devices.medium} {
        z-index: 1;
        transform: translate(0, ${({ menu }) => menu ? '100vh' : '50px'});
    }
    
    @media ${minDevices.medium} {
        /* TODO background-attachment doesn't work on firefox with this  */
        transform: translate(${({ menu }) => menu ? '55vw' : '100px'}, 0);
        width: calc(100vw - 100px);
        box-shadow: -5px 0 5px rgba(0,0,0,0.5);
    }
`

const MainPage = styled.div`
    display: ${props => props.ie ? 'block' : 'flex'};
    flex-direction: column;
`
